import '../style/Banner.css';

const Hero = () => {
  return (
    // Container ini akan menjadi latar belakang gambar Anda
    <div className="hero-banner-image"></div>
  );
}

export default Hero;
